import { render, staticRenderFns } from "./PublicationContactItem.vue?vue&type=template&id=9cc605b6&scoped=true&lang=pug&"
import script from "./PublicationContactItem.vue?vue&type=script&lang=js&"
export * from "./PublicationContactItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc605b6",
  null
  
)

export default component.exports